import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useRadios() {
  const queryKey = ['radios'];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      const json = [
        {
          $project: {
            ssi: true,
            type: true,
            label: true,
            firstContactTime: true,
            lastPoll: '$lastRadioPoll',
          },
        },
        {
          $lookup: {
            from: 'people',
            localField: '_id',
            foreignField: 'radioSsi',
            as: 'people',
          },
        },
        {
          $set: {
            assignmentCount: {
              $size: {
                $filter: {
                  input: '$people',
                  as: 'person',
                  cond: { $ne: ['$$person.deleted', true] },
                },
              },
            },
          },
        },
        { $unset: 'people' },
      ];

      log('Read', 'Radios');

      return api.post('pipeline/radios', { json, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
